import style from './style.module.scss'

export default function NotFound() {
	return <div className={style.root}>Not found</div>
}
